import { TasksWidgetItem, Widget, WidgetContentItemsList } from '../../Widget'

import { getTaskListItemProps } from './TaskWidget.utils'

function TaskWidget({
  Item = TasksWidgetItem,
  getItemPropsFromValue = getTaskListItemProps,
  isSkeleton,
  items,
  widgetContentItemsProps,
  widgetProps,
}) {
  return (
    <Widget
      {...widgetProps}
      headerProps={{
        contentProps: {
          actionsProps: {
            EditButton: null,
          },
        },
      }}
      isSkeleton={isSkeleton}
    >
      <WidgetContentItemsList
        {...widgetContentItemsProps}
        Item={Item}
        getItemPropsFromValue={getItemPropsFromValue}
        items={items}
      />
    </Widget>
  )
}

export default TaskWidget
